module.exports = __webpack_public_path__ + "img/healthcare_icon_4.587e163d.png";